import type { SceneStimulusCatalog, SceneStimulusEntry } from "../config/scene-stimulus-schema";
import { parseSceneStimulusCatalog } from "./scene-catalog-validation";

export class SceneStimulusCatalogRepository {
  private catalog: SceneStimulusCatalog | null = null;
  private readonly byId = new Map<string, SceneStimulusEntry>();

  async load(url = "./content/catalogs/scene-stimulus-catalog.json"): Promise<SceneStimulusCatalog> {
    if (this.catalog) return this.catalog;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Scene stimulus catalog request failed with ${response.status}`);
    this.catalog = parseSceneStimulusCatalog(await response.json());
    this.catalog.scenes.forEach((scene) => this.byId.set(scene.id, scene));
    return this.catalog;
  }

  getRequired(id: string): SceneStimulusEntry {
    const scene = this.byId.get(id);
    if (!scene) throw new Error(`Scene stimulus is absent from the catalog: ${id}`);
    return scene;
  }
}
